import React from 'react';
import './Toggle.css'

const ToggleSwitch = ({ isOn, handleToggle, disabled }) => {
  return (
    <div className={`gr-toggle-switch ${isOn ? 'gr-toggle-on' : ''} ${disabled? 'disabled':""}`} onClick={handleToggle}>
      <div className={`gr-toggle-handle ${isOn ? 'gr-toggle-on' : ''}`} />
    </div>
  );
};

export default ToggleSwitch;
